import sliceCreator from '../../index.jsx';
import {GET_SALES_TARGETS} from '../../../constants/index.jsx';
const _getAllSalesTargetsAction = sliceCreator('GET_SALES_TARGETS', GET_SALES_TARGETS, 'get');

const { asyncAction: getAllSalesTargetsAction, reducer, clearData: clearGetAllSalesTargetsAction } = _getAllSalesTargetsAction;

export default reducer;

export {
    getAllSalesTargetsAction,
    clearGetAllSalesTargetsAction
}